/**
 * Config Service
 *
 * Fetches configuration values from the backend API
 */

import api from './api';

export interface IntegrationConfig {
  traffic_filter_endpoint: string;
}

/**
 * Fetch integration configuration
 */
export async function getIntegrationConfig(): Promise<IntegrationConfig> {
  const response = await api.get<IntegrationConfig>('/api/config/integration');
  return response.data;
}

export const configService = {
  getIntegrationConfig,
};
